import React, { useMemo } from "react";
import { AppText, FlexDiv } from "src/Components/UI";
import styled from "styled-components";
import { Note, NoteInput } from "../DashboardV2/DetailedLeadCard/NotesTab";

interface INoteSection {
  leadData: any;
  contactOptions?: any[];
  noteHistoryData?: any[];
}

export const NoteSection: React.FC<INoteSection> = ({ leadData, contactOptions, noteHistoryData }) => {
  const sortedNoteHistoryData = useMemo(
    () => [...(noteHistoryData || [])].sort((a, b) => Number(b?.is_pinned_to_top) - Number(a?.is_pinned_to_top)),
    [noteHistoryData],
  );

  return (
    <Container>
      <AppText fontSize={16} fontWeight={500} lineHeight={22}>
        Notes
      </AppText>

      <NoteInput contactOptions={contactOptions?.slice(1) || []} leadId={leadData?.id} />

      <FlexDiv
        direction="column"
        gap={8}
        style={{ maxHeight: "calc(100vh - 356px)", overflowY: "auto" }}
        padding="0px 0px 24px 0px"
      >
        {sortedNoteHistoryData?.map((noteData) => (
          <Note key={noteData.id} noteData={noteData} />
        ))}
      </FlexDiv>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  width: 488px;
  min-width: 488px;
  @media (max-width: 1568px) {
    width: 344px;
    min-width: 344px;
  }

  height: 100%;

  padding: 24px 24px 0px 0px;
`;
